module.exports = __webpack_public_path__ + "img/cpzz11@2x.48e8ea39.png";